// function to reset style of body element after opening login modal
export default function resetBodyStyle(document) {
  if (document) {
    document.body.removeAttribute("style");
    document.body.removeAttribute("class");
  }
}
